<template>
	<hero-section />
	<stats-band />
	<about-section />
	<global-section />
	<products-section />
	<sectors-section />
	<services-section />
	<values-section />
	<signature-section />
	<download-cta />
	<contact-section />
</template>

<script setup>
import HeroSection from '@/components/HeroSection.vue'
import StatsBand from '@/components/StatsBand.vue'
import AboutSection from '@/components/AboutSection.vue'
import GlobalSection from '@/components/GlobalSection.vue'
import ProductsSection from '@/components/ProductsSection.vue'
import SectorsSection from '@/components/SectorsSection.vue'
import ServicesSection from '@/components/ServicesSection.vue'
import ValuesSection from '@/components/ValuesSection.vue'
import SignatureSection from '@/components/SignatureSection.vue'
import DownloadCta from '@/components/DownloadCta.vue'
import ContactSection from '@/components/ContactSection.vue'

defineOptions({ name: 'HomePage' })
</script>
